module.exports = __webpack_public_path__ + "img/translate-eleven.5d91f19b.png";